module.exports = __webpack_public_path__ + "static/digital-nomad-c1a8c06b9d7fbccbb959e437ffde781f.jpg";